import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

const STEP_LABELS = [
  { num: 1, label: 'Upload CV' },
  { num: 2, label: 'Your Info' },
  { num: 3, label: 'AI Analysis' },
  { num: 4, label: 'Questions' },
  { num: 5, label: 'Results' }
];

export const StepProgress = ({ step, error }) => (
  <>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginBottom: '2.5rem' }}>
      {STEP_LABELS.map((s, idx) => (
        <React.Fragment key={s.num}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
            <div style={{
              width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: 'var(--font-mono)', fontSize: '0.75rem', fontWeight: 600,
              background: step > s.num ? 'var(--success)' : step === s.num ? 'var(--brand-purple)' : 'var(--bg-elevated)',
              color: step >= s.num ? '#fff' : 'var(--text-muted)',
              border: `1px solid ${step >= s.num ? 'transparent' : 'var(--border-default)'}`,
              transition: 'all 0.3s'
            }} data-testid={`step-${s.num}`}>
              {step > s.num ? <CheckCircle size={16} /> : s.num}
            </div>
            <span style={{ fontSize: '0.65rem', fontFamily: 'var(--font-mono)', color: step >= s.num ? 'var(--text-primary)' : 'var(--text-muted)', letterSpacing: '0.05em' }}>
              {s.label}
            </span>
          </div>
          {idx < 4 && <div style={{ width: '40px', height: '1px', background: step > s.num ? 'var(--success)' : 'var(--border-default)', marginBottom: '20px', transition: 'background 0.3s' }} />}
        </React.Fragment>
      ))}
    </div>

    {error && (
      <div style={{ background: 'var(--error-bg)', border: '1px solid rgba(244,63,94,0.3)', borderRadius: 'var(--radius-md)', padding: '12px 16px', marginBottom: '1.5rem', display: 'flex', gap: '10px', alignItems: 'flex-start' }} data-testid="error-message">
        <AlertCircle size={18} color="var(--error)" style={{ flexShrink: 0, marginTop: '2px' }} />
        <p style={{ color: 'var(--error)', margin: 0, fontSize: '0.875rem' }}>{error}</p>
      </div>
    )}
  </>
);
